import { render, staticRenderFns } from "./skillsInput.vue?vue&type=template&id=4b028a6f&scoped=true&"
import script from "./skillsInput.vue?vue&type=script&lang=js&"
export * from "./skillsInput.vue?vue&type=script&lang=js&"
import style0 from "./skillsInput.vue?vue&type=style&index=0&id=4b028a6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b028a6f",
  null
  
)

export default component.exports